<template>
    <app-page-content>
        <app-title>Mi cuenta</app-title>
        <v-tabs
            color="primary"
            dark
            slider-color="yellow"
        >
            <v-tab>
                Correo
            </v-tab>
            <v-tab>
                Contraseña
            </v-tab>
            <v-tab-item>
                <app-change-email @confirm="onChangeEmail"></app-change-email>
            </v-tab-item>
            <v-tab-item>
                <app-change-password></app-change-password>
            </v-tab-item>
        </v-tabs>      
    </app-page-content>
</template>

<script>
import ChangePassword from './ChangePassword/ChangePassword.vue';
import ChangeEmail from './ChangeEmail/ChangeEmail.vue';
import authRepository from '../../repositories/auth.repository';
export default {
    components: {
        appChangePassword: ChangePassword,
        appChangeEmail: ChangeEmail
    },
    data(){
        return {
            active: null,
        }
    },
    methods: {
        async onChangeEmail(email) {
            const ar = {...authRepository};
            try {
                const { data } = await ar.updateEmail(this.user.id, email);
                if(data.status) {
                    this.$router.push({ name: 'udateEmailConfirm' });
                }else{
                    toastr.error(data.msg);
                }
            } catch(err) {
                toastr.error('Ocurrió un error al intentar actualizar el correo');
            }
        }
    },
    created() {
        if(!this.user) this.$router.push({ name: 'login' });
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/MyAccount/MyAccount.vue